import { render, staticRenderFns } from "./postcode-data-editor.vue?vue&type=template&id=78d23f2e&scoped=true&"
import script from "./postcode-data-editor.vue?vue&type=script&lang=ts&"
export * from "./postcode-data-editor.vue?vue&type=script&lang=ts&"
import style0 from "./postcode-data-editor.vue?vue&type=style&index=0&id=78d23f2e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d23f2e",
  null
  
)

export default component.exports